import { createAction } from 'redux-actions'

const ns = 'chat/'

export const setChatListFilter = createAction(`${ns}SET_CHAT_LIST_FILTER`)
export const setChatUnreadCount = createAction(`${ns}SET_CHAT_UNREAD_COUNT`)
export const setChatChannelMeta = createAction(`${ns}SET_CHAT_CHANNEL_META`)
